module.exports = __webpack_public_path__ + "static/media/Prinka.dc289dbd.jpg";